import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import bottlingService from "../services/bottlingService";

// Add Bottling Start
const addBottlingState = {
  addBottlingLoading: false,
  addBottlingData: null,
  addBottlingError: null,
};

const addBottlingData = createAsyncThunk(
  "bottling/addBottling",
  async (payload) => {
    return await bottlingService.createBottling(payload);
  },
);

const addBottlingReducer = createSlice({
  name: "addBottling",
  initialState: addBottlingState,
  extraReducers: (builder) => {
    builder.addCase(addBottlingData.pending, (state) => {
      state.addBottlingLoading = true;
    });
    builder.addCase(addBottlingData.fulfilled, (state, action) => {
      state.addBottlingLoading = false;
      state.addBottlingData = action.payload;
      state.addBottlingError = "";
    });
    builder.addCase(addBottlingData.rejected, (state, action) => {
      state.addBottlingLoading = false;
      state.addBottlingData = null;
      state.addBottlingError = action.error.message;
    });
  },
});

export const AddBottlingReducer = addBottlingReducer.reducer;
export const AddBottlingData = addBottlingData;
// Add Bottling End

// Update Bottling By Id Start
const updateBottlingState = {
  updateBottlingLoading: false,
  updateBottlingData: null,
  updateBottlingError: null,
};

const updateBottlingData = createAsyncThunk(
  "bottling/updateBottling",
  async (payload) => {
    return await bottlingService.updateBottling(payload);
  },
);

const updateBottlingReducer = createSlice({
  name: "updateBottlingData",
  initialState: updateBottlingState,
  extraReducers: (builder) => {
    builder.addCase(updateBottlingData.pending, (state) => {
      state.updateBottlingLoading = true;
    });
    builder.addCase(updateBottlingData.fulfilled, (state, action) => {
      state.updateBottlingLoading = false;
      state.updateBottlingData = action.payload;
      state.updateBottlingError = "";
    });
    builder.addCase(updateBottlingData.rejected, (state, action) => {
      state.updateBottlingLoading = false;
      state.updateBottlingData = null;
      state.updateBottlingError = action.error.message;
    });
  },
});

export const UpdateBottlingReducer = updateBottlingReducer.reducer;
export const UpdateBottlingData = updateBottlingData;
// Update Bottling End

// Get Bottling List Start
const getBottlingListState = {
  getBottlingListLoading: false,
  getBottlingListData: null,
  getBottlingListError: null,
};

const getBottlingList = createAsyncThunk(
  "bottling/bottlingList",
  async (payload) => {
    return await bottlingService.getBottlingList(payload);
  },
);

const getBottlingListReducer = createSlice({
  name: "getBottlingList",
  initialState: getBottlingListState,
  extraReducers: (builder) => {
    builder.addCase(getBottlingList.pending, (state) => {
      state.getBottlingListLoading = true;
    });
    builder.addCase(getBottlingList.fulfilled, (state, action) => {
      state.getBottlingListLoading = false;
      state.getBottlingListData = action.payload;
      state.getBottlingListError = "";
    });
    builder.addCase(getBottlingList.rejected, (state, action) => {
      state.getBottlingListLoading = false;
      state.getBottlingListData = null;
      state.getBottlingListError = action.error.message;
    });
  },
});

export const GetBottlingListReducer = getBottlingListReducer.reducer;
export const GetBottlingList = getBottlingList;
// Get Bottling List End

// Get Bottling Sub List Start
const getBottlingSubListState = {
  getBottlingSubListLoading: false,
  getBottlingSubListData: null,
  getBottlingSubListError: null,
};

const getBottlingSubList = createAsyncThunk(
  "bottling/bottlingSubList",
  async (payload) => {
    return await bottlingService.getBottlingSubList(payload);
  },
);

const getBottlingSubListReducer = createSlice({
  name: "getBottlingSubList",
  initialState: getBottlingSubListState,
  extraReducers: (builder) => {
    builder.addCase(getBottlingSubList.pending, (state) => {
      state.getBottlingSubListLoading = true;
    });
    builder.addCase(getBottlingSubList.fulfilled, (state, action) => {
      state.getBottlingSubListLoading = false;
      state.getBottlingSubListData = action.payload;
      state.getBottlingSubListError = "";
    });
    builder.addCase(getBottlingSubList.rejected, (state, action) => {
      state.getBottlingSubListLoading = false;
      state.getBottlingSubListData = null;
      state.getBottlingSubListError = action.error.message;
    });
  },
});

export const GetBottlingSubListReducer = getBottlingSubListReducer.reducer;
export const GetBottlingSubList = getBottlingSubList;
// Get Bottling Sub List End

// Delete Bottling Sub List Start
const deleteBottlingFromSubListState = {
  deleteBottlingFromSubListLoading: false,
  deleteBottlingFromSubListData: null,
  deleteBottlingFromSubListError: null,
};

const deleteBottlingFromSubList = createAsyncThunk(
  "bottling/deleteBottlingFromSubList",
  async (payload) => {
    return await bottlingService.deleteBottleFromSubList(payload);
  },
);

const deleteBottlingFromSubListReducer = createSlice({
  name: "deleteBottlingFromSubList",
  initialState: deleteBottlingFromSubListState,
  extraReducers: (builder) => {
    builder.addCase(deleteBottlingFromSubList.pending, (state) => {
      state.deleteBottlingFromSubListLoading = true;
    });
    builder.addCase(deleteBottlingFromSubList.fulfilled, (state, action) => {
      state.deleteBottlingFromSubListLoading = false;
      state.deleteBottlingFromSubListData = action.payload;
      state.deleteBottlingFromSubListError = "";
    });
    builder.addCase(deleteBottlingFromSubList.rejected, (state, action) => {
      state.deleteBottlingFromSubListLoading = false;
      state.deleteBottlingFromSubListData = null;
      state.deleteBottlingFromSubListError = action.error.message;
    });
  },
});

export const DeleteBottlingFromSubListReducer =
  deleteBottlingFromSubListReducer.reducer;
export const DeleteBottlingFromSubList = deleteBottlingFromSubList;
// Delete Bottling Sub List End
